import { render, staticRenderFns } from "./externalLinkIcon.vue?vue&type=template&id=2c2c0cb6&"
import script from "./externalLinkIcon.vue?vue&type=script&lang=js&"
export * from "./externalLinkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports